module.exports = __webpack_public_path__ + "img/2.e003ee06.png";